import { render, staticRenderFns } from "./FeedContentFollowUpCompanies.vue?vue&type=template&id=1d7a5d2a"
import script from "./FeedContentFollowUpCompanies.vue?vue&type=script&lang=js"
export * from "./FeedContentFollowUpCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports